// Client-side CSRF utilities

let csrfToken = null;

// Get CSRF token from the API
export async function getCsrfToken() {
  if (csrfToken) return csrfToken;
  
  try {
    const response = await fetch('/api/csrf');
    const data = await response.json();
    csrfToken = data.token;
    return csrfToken;
  } catch (error) {
    console.error('Failed to get CSRF token:', error);
    return null;
  }
}

// Add CSRF token to fetch options
export async function fetchWithCsrf(url, options = {}) {
  const token = await getCsrfToken();
  
  if (!token) {
    throw new Error('Failed to get CSRF token');
  }
  
  return fetch(url, {
    ...options,
    headers: {
      ...options.headers,
      'x-csrf-token': token,
    },
  });
}

// Reset token (call when authentication changes)
export function resetCsrfToken() {
  csrfToken = null;
}